// extracted by mini-css-extract-plugin
export default {"legendIndicator":"tha-z","legendNew":"uha-z"};